import type { FaireProductEntity } from "../../entity_types/product";

export const p_ac36dfzp8u: FaireProductEntity = {
  token: "p_ac36dfzp8u",
  type: "product",
  name: "Woon Black Rice",
  brandToken: "b_th428x9zzy",
  brandName: "Woon",
  imageUrl: "https://cdn.faire.com/fastly/f41e84136bbb3d1cc5834a7890e872336d9f2db432d34593051f830a80b4c644.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9e11541a8e17b0e5980f715b1e551e2631cf59408e0cd6332117905cbd1de8a1.jpeg",
    "https://cdn.faire.com/fastly/ce4227f633e69751cb05231c58fb8b7cbd9bb42f2d3a11df4013a701e804c941.jpeg",
    "https://cdn.faire.com/fastly/9faf81715c5a7a1ef5b75e62aa1d70c03d25b8b2b15c5dfe176038fd996ffd77.jpeg"
  ],
  priceDollars: 8,
  description: "Black rice is a Chinese staple, and a little of it goes a long way! We like to cook a small amount and mix it with our white rice, like we do with our Woon Fried Rice.\n\nInstructions: Use a 1:1.5 ratio for rice to water. Do not rinse before cooking. 1) Once the water comes to a boil, let simmer until all the water is absorbed. 2) Once finished, remove it from the heat. Let it sit for 10 minutes before serving.",
  tags: [],
  msrpDollars: 12,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-08T20:57:47.033Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
